import _defineProperty from "/builds/speachme/speachmeDesktop/speach-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.flat-map.js";
import "core-js/modules/es.iterator.reduce.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue, Watch } from "vue-facing-decorator";
import WToolTip from "@/components/tooltip/w-toolTip.vue";
import { ElTreeSelect } from "element-plus";
let WTreeSelect = class WTreeSelect extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "size", void 0);
    _defineProperty(this, "enabled", void 0);
    _defineProperty(this, "placeholder", void 0);
    _defineProperty(this, "modelValue", void 0);
    _defineProperty(this, "loading", void 0);
    _defineProperty(this, "valueKey", void 0);
    _defineProperty(this, "labelKey", void 0);
    _defineProperty(this, "disabledKey", void 0);
    _defineProperty(this, "invertDisabled", void 0);
    _defineProperty(this, "disabledTooltip", void 0);
    _defineProperty(this, "childrenKey", void 0);
    _defineProperty(this, "multiple", void 0);
    _defineProperty(this, "translateLabel", void 0);
    _defineProperty(this, "collapseTags", void 0);
    _defineProperty(this, "defaultExpandAll", void 0);
    _defineProperty(this, "dataTest", void 0);
    _defineProperty(this, "options", void 0);
  }
  get realValue() {
    return this.modelValue;
  }
  set realValue(val) {
    this.$emit('update:modelValue', val);
  }
  get treeProps() {
    return {
      value: this.valueKey,
      label: this.labelKey,
      children: this.childrenKey,
      disabled: data => this.isDisabledLeaf(data)
    };
  }
  isDisabledLeaf(data) {
    return this.disabledKey in data && (this.invertDisabled ? !data[this.disabledKey] : data[this.disabledKey]);
  }
  /**
   * Returns the display label based on the current translation settings.
   *
   * @param {string} label - The label to be translated or displayed as-is.
   * @return {string} The translated label if translation is enabled; otherwise, the original label.
   */
  labelToDisplay(label) {
    if (this.translateLabel) {
      return this.$t(label);
    } else {
      return label;
    }
  }
  onBlur() {
    this.$emit('blur', this.realValue);
  }
  /**
   * Checks if a node is a leaf node (has no children)
   * @param node - The tree node to check
   * @returns boolean indicating if the node is a leaf
   */
  isLeafNode(node) {
    return !node[this.childrenKey] || node[this.childrenKey].length === 0;
  }
  /**
   * Recursively collects all leaf node IDs from a given node
   * @param node - The node to process
   * @returns Array of leaf node IDs
   */
  getLeafNodeIds(node) {
    if (this.isLeafNode(node)) {
      return [node[this.valueKey]];
    }
    // Recursively collect IDs from all children
    return node[this.childrenKey].flatMap(child => this.getLeafNodeIds(child));
  }
  /**
   * Collects all leaf node IDs from an array of nodes
   * @param nodes - Array of nodes to process
   * @returns Array of unique leaf node IDs
   */
  collectLeafIds(nodes) {
    // Collect all IDs using reduce
    const allIds = nodes.reduce((acc, node) => {
      if (this.isLeafNode(node)) {
        acc.push(node[this.valueKey]);
      } else {
        acc.push(...this.getLeafNodeIds(node));
      }
      return acc;
    }, []);
    // Remove duplicates using Set
    return Array.from(new Set(allIds));
  }
  /**
   * Handles the check event from el-tree-select
   * @param currentNode - The current node being checked/unchecked
   * @param checkState - The current check state containing checked nodes
   */
  onCheck(currentNode, checkState) {
    const {
      checkedNodes
    } = checkState;
    const selectedLeafIds = this.collectLeafIds(checkedNodes);
    this.$emit('change', selectedLeafIds);
    this.$emit('update:modelValue', selectedLeafIds);
  }
  onChangeModelValue(newVal) {
    if (newVal !== this.realValue) {
      this.realValue = newVal;
    }
  }
};
__decorate([Prop({
  default: 'default'
})], WTreeSelect.prototype, "size", void 0);
__decorate([Prop({
  default: true
})], WTreeSelect.prototype, "enabled", void 0);
__decorate([Prop({
  default: ''
})], WTreeSelect.prototype, "placeholder", void 0);
__decorate([Prop({
  default: undefined
})], WTreeSelect.prototype, "modelValue", void 0);
__decorate([Prop({
  default: false
})], WTreeSelect.prototype, "loading", void 0);
__decorate([Prop({
  default: "value"
})], WTreeSelect.prototype, "valueKey", void 0);
__decorate([Prop({
  default: "label"
})], WTreeSelect.prototype, "labelKey", void 0);
__decorate([Prop({
  default: "disabled"
})], WTreeSelect.prototype, "disabledKey", void 0);
__decorate([Prop({
  default: false
})], WTreeSelect.prototype, "invertDisabled", void 0);
__decorate([Prop({
  default: "disabled"
})], WTreeSelect.prototype, "disabledTooltip", void 0);
__decorate([Prop({
  default: "children"
})], WTreeSelect.prototype, "childrenKey", void 0);
__decorate([Prop({
  default: false
})], WTreeSelect.prototype, "multiple", void 0);
__decorate([Prop({
  default: false
})], WTreeSelect.prototype, "translateLabel", void 0);
__decorate([Prop({
  default: false
})], WTreeSelect.prototype, "collapseTags", void 0);
__decorate([Prop({
  default: false
})], WTreeSelect.prototype, "defaultExpandAll", void 0);
__decorate([Prop()], WTreeSelect.prototype, "dataTest", void 0);
__decorate([Prop({
  default: []
})], WTreeSelect.prototype, "options", void 0);
__decorate([Watch('modelValue')], WTreeSelect.prototype, "onChangeModelValue", null);
WTreeSelect = __decorate([Component({
  components: {
    WToolTip,
    ElTreeSelect
  },
  emits: ['blur', 'change']
})], WTreeSelect);
export default WTreeSelect;